import { render, staticRenderFns } from "./InitialLayout.vue?vue&type=template&id=f26897c0&scoped=true"
import script from "./InitialLayout.vue?vue&type=script&lang=ts"
export * from "./InitialLayout.vue?vue&type=script&lang=ts"
import style0 from "./InitialLayout.vue?vue&type=style&index=0&id=f26897c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26897c0",
  null
  
)

export default component.exports